var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { services } from '@quandis/qbo4.ui';
import { ILoggerToken } from './ILogger.js';
import { IConfigurationToken } from '@quandis/qbo4.configuration';
import { inject, injectable } from 'tsyringe';
export class AppInsightsConfiguration {
    constructor() {
        this.config = {};
        this.trackPageView = false;
    }
}
/**
 *  Define a token for the ILoggerService interface
 */
export const AppInsightsConfigurationToken = 'AppInsightsConfigurationToken';
let AppInsightsLogger = class AppInsightsLogger {
    constructor(config) {
        this.config = config;
        if (config.config?.connectionString || config.config?.instrumentationKey) {
            this.instance = new ApplicationInsights(config);
            this.instance.loadAppInsights();
            if (config.trackPageView)
                this.instance.trackPageView();
        }
        else
            console.warn(`AppInsightsLogger configuraiton has no connectionString or instrumentaitonKey.`);
        this.config = config;
    }
    logTrace(message, ...args) {
        this.instance?.trackTrace({ message: this.formatMessage(message, args), severityLevel: 0 });
    }
    logDebug(message, ...args) {
        this.instance?.trackTrace({ message: this.formatMessage(message, args), severityLevel: 1 });
    }
    logInformation(message, ...args) {
        this.instance?.trackTrace({ message: this.formatMessage(message, args), severityLevel: 2 });
    }
    logWarning(message, ...args) {
        this.instance?.trackTrace({ message: this.formatMessage(message, args), severityLevel: 3 });
    }
    logError(message, error, ...args) {
        this.instance?.trackException({ exception: error ?? new Error(this.formatMessage(message, args)) });
    }
    logCritical(message, error, ...args) {
        // Assuming you might want to treat critical errors differently
        this.instance?.trackException({ exception: error ?? new Error(this.formatMessage(message, args)), properties: { severity: 'critical' } });
    }
    log(level, message, error, ...args) {
        if (error)
            this.instance?.trackException({ exception: error, properties: { message: this.formatMessage(message, args) } });
        else
            this.instance?.trackTrace({ message: this.formatMessage(message, args), severityLevel: level });
    }
    formatMessage(message, args) {
        return args.length > 0 ? `${message}, ${args.join(', ')}` : message;
    }
};
AppInsightsLogger = __decorate([
    injectable(),
    __param(0, inject(AppInsightsConfigurationToken)),
    __metadata("design:paramtypes", [AppInsightsConfiguration])
], AppInsightsLogger);
export { AppInsightsLogger };
function myFactory() {
    const config = services.container.resolve(IConfigurationToken);
    const aiConfig = config.getSection('ApplicationInsights').bind(AppInsightsConfiguration);
    return aiConfig;
}
// const config = services.container.resolve<QboConfig>(IConfigurationToken);
// const aiConfig = config.get('ApplicationInsights').bind(AppInsightsConfiguration);
// services.container.register(AppInsightsConfiguration, { useValue: aiConfig });
services.container.registerSingleton(AppInsightsLogger);
services.container.register(ILoggerToken, { useToken: AppInsightsLogger });
services.container.register(AppInsightsConfigurationToken, { useFactory: myFactory });
//# sourceMappingURL=ApplicationInsights.js.map